<t4-header icon="glyphicon-stats">
</t4-header>
<t4-container title="{{ 'T4.Settings.ObjectTypeClass.lblTypeClassSys' | translate : 'Type Class System' }}">
  <t4-container title="{{ 'T4.Settings.ObjectTypeClass.ObjectTypeClasses' | translate : 'Object Type Classes' }}" style="margin: 10px;">
    <t4-data-table [rawData]="objectTypeClasses" headline="" matSort [allowPaging]="false" [allowFilter]="true" [allowAdd]="true" [autoGenerateColumns]="false" (addClicked)="openObjectTypeClass()">
      <ng-container matColumnDef="Id">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          <button mat-icon-button (click)="openObjectTypeClassDetails(row)">
            <mat-icon>create</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ObjectTypeClass.colName' | translate : 'Name' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Name }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Description">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ObjectTypeClass.Description' | translate : 'Description' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ row.Description }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Overridden">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ObjectTypeClass.lblOverides' | translate : 'Overides' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ getClassNameById(row.OverridesClassId) }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Delete">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          <button mat-icon-button (click)="deleteTypeClass(row)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
    </t4-data-table>
  </t4-container>

  @if(ineheritedObjectTypeClasses?.length > 0) {
  <t4-container title="{{ 'T4.Settings.ObjectTypeClass.InheritedObjectTypeClasses' | translate : 'Inherited Object Type Classes' }}" style="margin: 10px;">
    <t4-data-table [rawData]="ineheritedObjectTypeClasses" headline="" matSort [allowPaging]="false" [allowFilter]="true" [autoGenerateColumns]="false">
     
      <ng-container matColumnDef="Id">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"></mat-header-cell>
        <mat-cell *matCellDef="let row" style="max-width: 75px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          @if(!row.isOverridden)
          {
          <button mat-icon-button (click)="openObjectTypeClass(row, false)">
            <mat-icon>open_in_new</mat-icon>
          </button>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Name">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ObjectTypeClass.colName' | translate : 'Name' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;" [ngClass]="{'strike-through': row.isOverridden }">{{ row.Name }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Description">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ObjectTypeClass.Description' | translate : 'Description' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;" [ngClass]="{'strike-through': row.isOverridden }">{{ row.Description }}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="Overrides">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;">{{ 'T4.Settings.ObjectTypeClass.lblOverides' | translate : 'Overides' }}</mat-header-cell>
        <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:150px;" [ngClass]="{'strike-through': row.isOverridden }">{{ getClassNameById(row.OverridesClassId) }}</mat-cell>
      </ng-container>
    </t4-data-table>
  </t4-container>
  }
</t4-container>

